<!--
 * @Author: your name
 * @Date: 2021-08-16 14:23:41
 * @LastEditTime: 2024-02-22 16:07:04
 * @LastEditors: daidongyu daidongyu@cnuri.cn
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /my-activation/src/add/index.vue
-->
<template>
  <div class="app">
    <loading v-if="load"></loading>
    <div class="bor" v-if="prom"></div>
    <div class="tishi" v-if="prom">网络链接异常</div>
    <div
      style="display: none;this is padding data:填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充填充">
    </div>
  </div>
  </div>
</template>
<script>
import { G } from '../page/wxget'
export default {
  name: 'add',
  data() {
    return {
      load: false,
      card: '',
      stat: '',
      code: '',
      prom: false,
      Tips: '11',
      goto: null,
    }
  },
  mounted() {
    // alert(
    //   "这里是addddddd.vue",
    //   "-----",
    //   this.$route.query + "------" + JSON.stringify(this.$route.query)
    // );
    console.log(this.$route, 'rorororororo')
    this.stat = this.$route.query.stat
    this.code = this.$route.query.code
    this.goto = this.$route.query.goto
    this.load = true
    console.log(this.$route.query, 'this.$route.query.goto');
    if (this.$route.query.goto && this.$route.query.goto === 'Recharge') {

      if (this.$route.query.storeID) {
        localStorage.setItem('storeID', this.$route.query.storeID)
        localStorage.setItem('storeName', this.$route.query.storeName)
      } else {
        localStorage.setItem('storeID', '')
        localStorage.setItem('storeName', '')
      }
    } else {
      localStorage.setItem('storeID', '')
      localStorage.setItem('storeName', '')
    }
    localStorage.setItem('appcode', this.stat)
    localStorage.setItem('code', this.code)
    localStorage.setItem('companyID', this.$route.query.companyID)
    this.load = false
    localStorage.setItem('cardHref', true)
    this.$router.push({
      path: `/BindingMenmberCard?goto=${this.$route.query.goto}`,
    })

    // this.R(
    //   "QueryVIP",
    //   { appcode: this.stat, code: this.code },
    //   r => {
    //     localStorage.setItem("appcode", this.stat);
    //     localStorage.setItem("code", this.code);
    //     if (r.data.table1 != undefined) {
    //       this.load = false;
    //       console.log(r.data.table1[0]);
    //       // localStorage.setItem("VIPNO", r.data.table1[0].VIPNO);
    //       // localStorage.setItem("Integral", r.data.table1[0].Integral);
    //       // localStorage.setItem("Money", r.data.table1[0].Money);
    //       // this.$router.push({
    //       //   path: "/BindingMenmberCard"
    //       // });
    //     } else {
    //       this.load = false;
    //       // this.$router.push({ path: "/BindingMember" });
    //     }
    //     this.$router.push({
    //       path: "/BindingMenmberCard"
    //     });
    //   },
    //   err => {
    //     this.load = false;
    //     this.prom = true;
    //     alert(err);
    //   }
    // );
  },
  methods: {
    GetQueryString(name) {
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
      var r = window.location.search.substr(1).match(reg) //search,查询？后面的参数，并匹配正则
      if (r != null) return unescape(r[2])
      return null
    },
  },
}
</script>
<style scoped>
.bor {
  width: 140px;
  height: 30px;
  border-radius: 3px;
  background: #000;
  position: fixed;
  top: 50%;
  left: 50%;
  opacity: 0.7;
  margin-left: -70px;
  margin-top: -15px;
  z-index: 99;
}

.tishi {
  width: 140px;
  height: 30px;
  border-radius: 3px;
  color: #fff;
  position: fixed;
  top: 50%;
  left: 50%;
  margin-left: -70px;
  margin-top: -15px;
  z-index: 999;
  font-size: 10px;
  text-align: center;
  line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/add/index.vue